import { LanguageResponse } from './Analytics';

export interface LanguageUsage {
	name: string;
	value: number;
}

export const aggregateLanguageUsage = (languageData: LanguageResponse[]) => {
	const languageMap = new Map<string, number>();

	languageData.forEach((language) => {
		let lang = language.metadata.activeLanguage || language.metadata.deviceLanguage;
		if (lang === 'zh') {
			lang = 'zh-Hans'; // Normalize 'zh' to 'zh-Hans' for consistency
		}

		languageMap.set(lang, (languageMap.get(lang) || 0) + 1);
	});

	const languageUsage: LanguageUsage[] = Array.from(languageMap).map(([name, value]) => ({
		name,
		value,
	}));

	return languageUsage;
};
